export const dictionaryErrors = {
  METDESXX: "Metadato",
  METIDXXX: "Nombre Maquina del Metadato",
  METTIPXX: "Tipo de Metadato",
  METOPXXX: "Opciones Disponibles",
};
